export default {
  listeBySections: (items, sections) => {
    const bySections = [];

    if (items && Array.isArray(items)) {
      const divers = {
        libelle: "Divers",
        valeur: -1,
        articles: []
      }
      for (const item of items) {
        const article = item.attributes.produit ? item.attributes.produit.data.attributes : item.attributes;
        const section = sections.find(rayon => parseInt(article.categorie_parente_id) === parseInt(rayon.valeur));
        if (!section) {
          divers.articles.push(item);
        } else {
          const inBySection = bySections.find(rayon => parseInt(section.valeur) === parseInt(rayon.valeur));
          if (inBySection) {
            inBySection.articles.push(item);
          } else {
            bySections.push({
              libelle: section.libelle,
              valeur: section.valeur,
              articles: [item]
            });
          }
        }
      }
      bySections.sort((a, b) => { return a.valeur - b.valeur });
      if (divers.articles.length > 0) {
        bySections.push(divers);
      }
    }
    return bySections;
  },
  mapIndisponibles(metaItems) {
    return metaItems.map((item) => {
      return {
        id: item.id ? item.id : item.produit_id,
        attributes: {
          designation: item.designation,
          produit: {
            data: {
              id: item.produit_id,
              attributes: {
                visuel: item.visuel,
                designation: item.designation,
                en_stock: false,
                type: "indisponible"
              }
            }
          }
        }
      };
    });
  },
  mapIndisponibleFromPanier(item) {
    return {
      id: item.id,
      attributes: {
        visuel: item.visuel,
        designation: item.designation,
        en_stock: false,
        type: item.type
      }
    }
  }
};
